import React, {useEffect} from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField
} from "@material-ui/core";
import {useFormik} from "formik";

const EditFolderDialog = (props) => {
    const {open, onClose, submitCallback, initialValues} = props

    const onSubmit = async (values) => {
        await submitCallback(values)
    }

    const {getFieldProps, resetForm, submitForm, setValues} = useFormik({
        initialValues: {
            id: undefined,
            name: ''
        },
        onSubmit: onSubmit
    })

    const handleCloseDialog = () => {
        onClose()
        resetForm()
    }

    const handleSubmitButtonClick = async () => {
        await submitForm()
        handleCloseDialog()
    }

    useEffect(() => {
        if (open && initialValues){
            setValues(initialValues)
        }
    }, [open, initialValues])

    return (
        <Dialog open={open} onClose={handleCloseDialog} maxWidth={"sm"} fullWidth>
            <DialogTitle>Редактирование папки</DialogTitle>
            <DialogContent>
                <DialogContentText>Введите название</DialogContentText>
                <TextField fullWidth name={'name'} {...getFieldProps('name')}/>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog}>
                    Отмена
                </Button>
                <Button onClick={handleSubmitButtonClick}>
                    Сохранить
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditFolderDialog;